<template>
	<div class="oohdesk-id">
		<div class="oohdesk-id__select">
			<a-select
				style="width: 100%"
				placeholder="Выберите OOHDESK_ID"
				show-search
				option-filter-prop="children"
				allowClear
				:filter-option="filterOption"
				@change="onSelectOohdeskId"
			>
				<a-select-option v-for="coreUser in normalizedCoreUsers" :key="coreUser.id">
					{{ coreUser.id }} ({{ coreUser.email }})
				</a-select-option>
			</a-select>

			<a-button :disabled="!selectedOohdeskId" :loading="isLoading" @click="onSubmitOohdeskId()">ОК</a-button>
		</div>

		<a-button type="link" @click="onOpenAdvancedSelect()">Расширенный выбор</a-button>

		<a-divider />

		<div class="oohdesk-id__create-new">
			<a-button :loading="isCreatingNewOohdeskId" @click="onCreateNewOohdeskId()">Создать новый OOHDESK ID</a-button>
			<a-tooltip class="oohdesk-id__create-new-tooltip">
				<template slot="title">
					<span>
						Создать нового пользователя для сервиса авторизации с новым OOHDESK ID, а данные для этого пользователя возьмутся из
						импортированного.
					</span>
				</template>

				<a-button type="dashed">?</a-button>
			</a-tooltip>
			<div></div>
		</div>

		<Modal v-model="isModalVisible" :confirmLoading="isLoading" :width="1000" title="Выбор OOHDESK ID" centered>
			<template #default>
				<UserTable
					:hasActions="false"
					:rowSelection="{ type: 'radio', selectedRowKeys: [selectedOohdeskId], onSelect: onAdvancedSelectOohdeskId }"
					:users="normalizedCoreUsers"
					@link-product="$emit('refresh', $event)"
					@unlink-product="$emit('refresh', $event)"
					@delete-sessions="$emit('refresh', $event)"
					@delete-user="$emit('refresh', $event)"
				/>
			</template>

			<template slot="footer">
				<a-button type="primary" :disabled="!selectedOohdeskId" @click="onSubmitOohdeskId()">Подтвердить</a-button>
			</template>
		</Modal>
	</div>
</template>

<script>
import { Modal } from "ant-design-vue"

export default {
	name: "UserTableImportOohdeskId",

	components: {
		Modal,
		UserTable: () => import("@/components/UserTable")
	},

	props: {
		user: { type: Object, required: true },
		coreUsers: { type: Array, required: true }
	},

	data() {
		return {
			selectedOohdeskId: null,
			isLoading: false,
			isCreatingNewOohdeskId: false,
			isModalVisible: false
		}
	},

	computed: {
		/**
		 * Если в этом одеск айди уже есть привязываемый нами продукт, то пропускаем его
		 */
		normalizedCoreUsers() {
			const userProductIds = this.user.products.map(p => Number(p.id))
			return this.coreUsers.filter(coreUser => {
				const coreProductIds = coreUser.products.map(p => Number(p.id))
				const hasProduct = userProductIds.some(userProductId => coreProductIds.includes(userProductId))
				return !hasProduct
			})
		}
	},

	methods: {
		/**
		 * Обработчик фильтра для дропдауна
		 */
		filterOption(input, option) {
			return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		},

		/**
		 * Открыть расширенный выбор одеск айди
		 */
		onOpenAdvancedSelect() {
			this.isModalVisible = true
		},

		/**
		 * Обработать выбор одеск айди
		 */
		onSelectOohdeskId(coreUserId) {
			this.selectedOohdeskId = coreUserId
		},

		/**
		 * Обработать расширенный выбор одеск айди
		 */
		onAdvancedSelectOohdeskId(selectedRow) {
			this.selectedOohdeskId = selectedRow.id
		},

		/**
		 * Подтвердить выбранный одеск айди
		 */
		async onSubmitOohdeskId() {
			this.isLoading = true

			try {
				for (let i = 0; i < this.user.ids.length; i++) {
					const data = {
						importUserId: this.user.ids[i],
						oohdeskId: this.selectedOohdeskId
					}
					await this.$context.adminImportedUserService.linkUser(data)
				}

				this.$alert.success("OOHDESK ID выбран")
				this.$emit("refresh")

				this.selectedOohdeskId = null
				this.isModalVisible = false
			} catch (message) {
				this.$alert.error(message)
			}

			this.isLoading = false
		},

		/**
		 * Создать новый одеск айди (то есть нового юзера с новым одеск айди, а данные
		 * для этого юзера возьмутся из импортированного)
		 */
		async onCreateNewOohdeskId() {
			this.isCreatingNewOohdeskId = true

			try {
				// Первый продукт делаем через создание одеск айди
				const newUser = await this.$context.adminImportedUserService.createOohdeskId(this.user.ids[0])

				// Остальные просто привязываем к существующему
				for (let i = 1; i < this.user.ids.length; i++) {
					const data = {
						importUserId: this.user.ids[i],
						oohdeskId: this.selectedOohdeskId
					}
					await this.$context.adminImportedUserService.linkUser(data)
				}

				this.$alert.success(`OOHDESK ID создан (${newUser.id})`)

				this.$emit("refresh")
			} catch (message) {
				this.$alert.error(message)
			}

			this.isCreatingNewOohdeskId = false
		}
	}
}
</script>

<style lang="scss" scoped>
.ant-btn-link {
	padding: 0;
}

.ant-divider-horizontal {
	margin: 10px -15px 20px;
	width: calc(100% + 30px);
}

.oohdesk-id {
	&__select {
		display: flex;
	}

	&__create-new {
		&-tooltip {
			margin-left: 10px;
		}
	}
}
</style>
